import React, { useMemo } from "react";

import { IconButton, Box } from "@mui/material";
import { Visibility, Edit, Delete } from "@material-ui/icons";

import { NotificationTabKey } from "../../model";
import { getActionsForTab } from "./table.rules";

import { INotification } from "@modules/notifications/model/INotifications";

export interface ActionsCellProps {
  align?: "left" | "right" | "center";
  currentTab: NotificationTabKey;
  notification: INotification;
  onView(notification: INotification): void;
  onEdit(notification: INotification): void;
  onDelete(notification: INotification): void;
  onOpenModalReadConfirmation: (notification: INotification) => void;
}

const justifyMap = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
} as const;

const ActionsCell: React.FC<ActionsCellProps> = ({
  notification,
  currentTab,
  align = "right",
  onView,
  onEdit,
  onDelete,
  onOpenModalReadConfirmation,
}) => {
  const actions = useMemo(() => getActionsForTab(currentTab), [currentTab]);

  return (
    <Box
      sx={{
        justifyContent: justifyMap[align],
        textAlign: align,
        whiteSpace: "nowrap",
        display: "flex",
        gap: 0.5,
      }}
    >
      {actions.canReadConfirmation && (
        <IconButton
          onClick={() => onOpenModalReadConfirmation(notification)}
          color="primary"
        >
          <Visibility />
        </IconButton>
      )}
      {actions.canView && (
        <IconButton
          onClick={() => onView(notification)}
          aria-label="Visualizar"
          color="primary"
        >
          Visualizar
        </IconButton>
      )}
      {actions.canEdit && (
        <IconButton
          onClick={() => onEdit(notification)}
          aria-label="Editar"
          color="primary"
        >
          <Edit />
        </IconButton>
      )}
      {actions.canDelete && (
        <IconButton
          onClick={() => onDelete(notification)}
          aria-label="Excluir"
          color="primary"
        >
          <Delete />
        </IconButton>
      )}
    </Box>
  );
};

export default ActionsCell;
